<div class="pt-3">
  <span class="f-family-bold">{{ label }}</span>
  <br />
  <span class="f-color-regular">
    <ng-content></ng-content>
  </span>
</div>
